import { render, staticRenderFns } from "./SavingsDetailsTable.vue?vue&type=template&id=1ca8508b&scoped=true&"
import script from "./SavingsDetailsTable.vue?vue&type=script&lang=js&"
export * from "./SavingsDetailsTable.vue?vue&type=script&lang=js&"
import style0 from "./SavingsDetailsTable.vue?vue&type=style&index=0&id=1ca8508b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca8508b",
  null
  
)

export default component.exports